import { render } from "./Eye.vue?vue&type=template&id=1ed834dc"
const script = {}

import exportComponent from "/Users/niteshdas/Projects/wordpress/wp-content/plugins/easy-restaurant-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__